import { Outlet } from 'react-router-dom';
import { HairSessionProvider, useHairSession } from './context/HairSessionContext';
import { HairAnalysisPlanProvider } from './context/HairAnalysisPlanContext';
import { PageBackgroundSync } from './components/PageBackgroundSync';
import { hasFranchiseFlowAuth as hasEnterpriseFranchiseFlowAuth } from '../../../enterprise/shared/franchiseFlowAuth';
import { hasFranchiseFlowAuth as hasNaturalsFranchiseFlowAuth } from '../../../naturals/shared/franchiseFlowAuth';
import { hasFranchiseFlowAuth as hasNyafazEpFranchiseFlowAuth } from '../../../nyafaz-ep/shared/franchiseFlowAuth';
import EnterpriseHairAnalyzeNavBar from '../../../enterprise/salon/components/HairAnalyzeNavBar';
import NaturalsHairAnalyzeNavBar from '../../../naturals/salon/components/HairAnalyzeNavBar';
import NyafazEpHairAnalyzeNavBar from '../../../nyafaz-ep/salon/components/HairAnalyzeNavBar';
import EnterpriseSalonLandingBackground from '../../../enterprise/salon/components/SalonLandingBackground';
import NaturalsSalonLandingBackground from '../../../naturals/salon/components/SalonLandingBackground';
import EnterprisePageFooter from '../../../enterprise/salon/components/PageFooter';
import NaturalsPageFooter from '../../../naturals/salon/components/PageFooter';
import { getSalonAppSessionToken as getEnterpriseSalonAppSessionToken } from '../../../enterprise/salon/utils/salonAppSessionToken';
import { getSalonAppSessionToken as getNaturalsSalonAppSessionToken } from '../../../naturals/salon/utils/salonAppSessionToken';
import { getSalonAppSessionToken as getNyafazEpSalonAppSessionToken } from '../../../nyafaz-ep/salon/utils/salonAppSessionToken';
import EnterpriseSalonStyles from '../../../enterprise/salon/EnterpriseSalonStyles';
import NaturalsSalonStyles from '../../../naturals/salon/EnterpriseSalonStyles';
import NyafazEpSalonStyles from '../../../nyafaz-ep/salon/EnterpriseSalonStyles';
import EnterpriseModernDialogHost from '../../../enterprise/admin-shared/ModernDialogHost';
import NaturalsModernDialogHost from '../../../naturals/admin-shared/ModernDialogHost';
import { resolveHairTenantPortal } from './config/hairApp';
import './styles/PageBackground.css';
import './styles/ActionButtons.css';

import NyafazEpSalonLandingBackground from '../../../nyafaz-ep/salon/components/SalonLandingBackground';
import NyafazEpPageFooter from '../../../nyafaz-ep/salon/components/PageFooter';
import NyafazEpModernDialogHost from '../../../nyafaz-ep/admin-shared/ModernDialogHost';

function HairFlowLayoutInner() {
  const portal = resolveHairTenantPortal();
  const isNaturals = portal === 'naturals';
  const isNyafazEp = portal === 'nyafaz_ep';
  const showLuxShell =
    typeof window !== 'undefined' &&
    (isNyafazEp
      ? hasNyafazEpFranchiseFlowAuth()
      : isNaturals
        ? hasNaturalsFranchiseFlowAuth()
        : hasEnterpriseFranchiseFlowAuth());
  const { token: hairToken } = useHairSession();
  const pageSetupToken = String(
    hairToken ||
      (isNyafazEp
        ? getNyafazEpSalonAppSessionToken()
        : isNaturals
          ? getNaturalsSalonAppSessionToken()
          : getEnterpriseSalonAppSessionToken()) ||
      '',
  ).trim();

  const SalonStyles = isNyafazEp ? NyafazEpSalonStyles : isNaturals ? NaturalsSalonStyles : EnterpriseSalonStyles;
  const SalonLandingBackground = isNyafazEp
    ? NyafazEpSalonLandingBackground
    : isNaturals
      ? NaturalsSalonLandingBackground
      : EnterpriseSalonLandingBackground;
  const HairAnalyzeNavBar = isNyafazEp
    ? NyafazEpHairAnalyzeNavBar
    : isNaturals
      ? NaturalsHairAnalyzeNavBar
      : EnterpriseHairAnalyzeNavBar;
  const PageFooter = isNyafazEp ? NyafazEpPageFooter : isNaturals ? NaturalsPageFooter : EnterprisePageFooter;
  const ModernDialogHost = isNyafazEp
    ? NyafazEpModernDialogHost
    : isNaturals
      ? NaturalsModernDialogHost
      : EnterpriseModernDialogHost;
  const shellClass = isNyafazEp
    ? 'naturals-salon-lux hair-analyze-shell fi-lux-theme'
    : isNaturals
      ? 'naturals-salon-lux hair-analyze-shell fi-lux-theme'
      : 'enterprise-salon-lux hair-analyze-shell fi-lux-theme';
  const contentClass = isNyafazEp || isNaturals ? 'naturals-salon-lux__content' : 'enterprise-salon-lux__content';
  const modalRootId = isNyafazEp || isNaturals ? 'naturals-salon-modal-root' : 'enterprise-salon-modal-root';

  return (
    <>
      <PageBackgroundSync />
      {showLuxShell ? (
        <div className={shellClass}>
          <SalonStyles />
          <SalonLandingBackground source="pageSetup" sessionToken={pageSetupToken || null} />
          <div className={contentClass}>
            <HairAnalyzeNavBar />
            <Outlet />
            <PageFooter />
          </div>
          <ModernDialogHost key="hair-modern-dialog-host" />
          <div id={modalRootId} />
        </div>
      ) : (
        <Outlet />
      )}
      {!showLuxShell ? <ModernDialogHost key="hair-modern-dialog-host" /> : null}
    </>
  );
}

/** Shared layout for standalone hair-analyzer app and main SPA `/hair` routes. */
export default function HairFlowLayout() {
  return (
    <HairSessionProvider>
      <HairAnalysisPlanProvider>
        <HairFlowLayoutInner />
      </HairAnalysisPlanProvider>
    </HairSessionProvider>
  );
}
